import { Directive, OnInit, Input, HostBinding } from '@angular/core';
import { BarComponent } from '../bar/bar.component';

const progressConfig = {
  animate: true,
  max: 100
};

@Directive({ selector: 'bs-progress, [progress]' })
export class ProgressDirective implements OnInit {
  @Input() public animate: boolean;

  @HostBinding('attr.max')
  @Input() public get max(): number {
    return this._max;
  }

  @HostBinding('class') public addClass = 'progress';

  public set max(v: number) {
    this._max = v;
    this.bars.forEach((bar: BarComponent) => {
      bar.recalculatePercentage();
    });
  }

  public bars: Array<any> = [];

  public _max: number;

  constructor() {
  }

  ngOnInit() {
    this.animate = this.animate !== false;
    this.max = typeof this.max === 'number' ? this.max : progressConfig.max;
  }


  public addBar(bar: BarComponent) {
    if (!this.animate) {
      bar.transition = 'none';
    }
    this.bars.push(bar);
  }

  public removeBar(bar: BarComponent) {
    this.bars.splice(this.bars.indexOf(bar), 1);
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/directive/progress.directive.ts